module.exports = __webpack_public_path__ + "static/bch-logo-bda40c2fa6c4d75432a5c807349db20a.jpg";